import { render, staticRenderFns } from "./SearchGoods.vue?vue&type=template&id=77fb49c1&scoped=true"
import script from "./SearchGoods.vue?vue&type=script&lang=ts"
export * from "./SearchGoods.vue?vue&type=script&lang=ts"
import style0 from "./SearchGoods.vue?vue&type=style&index=0&id=77fb49c1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77fb49c1",
  null
  
)

export default component.exports